import { useFiltersContext, usePlannerContext } from '@/context'
import { PlannerQueries } from '@/graphql/queries/planner.queries'
import { PlannerItemResponse } from '@/types/Planner'
import { formatDate } from '@/util'
import { getPlannerItemColor, isItemUnscheduled } from '@/util/PlannerUtil'

import { useGraphql } from '../useGraphql'

const usePlanner = () => {
  const { startWeekDate, endWeekDate } = usePlannerContext()
  const startFilter = formatDate(startWeekDate, 'yyyy-MM-dd')
  const endFilter = formatDate(endWeekDate, 'yyyy-MM-dd')
  const [{ marketSegmentFilter }] = useFiltersContext()
  return useGraphql<{ dailyPlanner: PlannerItemResponse[] }>(
    PlannerQueries.QUERY_KEY,
    PlannerQueries.getDailyPlanner(),
    {
      filter: {
        marketSegmentIds: marketSegmentFilter.marketSegmentIds,
        dateMin: startFilter,
        dateMax: endFilter,
      },
    },
    {
      select: (data: { dailyPlanner: PlannerItemResponse[] }) => {
        const plannerData = data?.dailyPlanner?.map((item) => {
          return {
            ...item,
            isScheduled: !isItemUnscheduled(item),
            color: getPlannerItemColor(item?.recordType),
          }
        })
        return { dailyPlanner: plannerData }
      },
    },
  )
}

export default usePlanner
